import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { AnalyticsService, APP_SETTINGS, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { SettingService } from 'src/app/core/services/settings/settings.service';
import { is3rdPartyHost, isExternalThirdPartyHost } from 'src/app/shared/utils/utils';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NavbarComponent } from '../navbar/navbar.component';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        RouterLink,
        NavbarComponent,
        NgClass,
        NgFor,
    ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subsciption: ISubscription;
  public hideShowSearchFlag = false;
  public search_section: string;
  public search_key = '';

  @ViewChild('navbar')
  navbar: ElementRef;

  public ossLinks: {};

  public APP_SETTINGS;
  public brand_icon_image;
  public brand_icon_color;
  public brandType: boolean;
  public isExternal: boolean;
  public is3rdParty: boolean = isExternalThirdPartyHost();
  public isCar: boolean = true;
  public showCar: boolean = false;
  public showBike: boolean = false;

  public hideNavbar: boolean;

  public subscription: ISubscription[] = [];

  screenWidth: number;
  setBackgroundStyle: {};
  setFontStyle: {};
  imgSrc = ''
  RRHideLegacy: boolean;

  bulletinLabel = 'TRI Bulletins';
  userRoles = {};
  searchSectionDisplay: string;

  openParts24Link(): void {
    window.open(this.settingService.getAppSettings().parts24HeaderLink, '_blank');
  }

  constructor(
    private readonly router: Router, 
    private readonly route: ActivatedRoute,
    private readonly userProfileService: UserProfileService,
    private readonly utilityService: UtilityService,
    private readonly analyticsService: AnalyticsService,
    private readonly settingService: SettingService,
    private readonly cdRef: ChangeDetectorRef) {
    this.search_section = 'SIB';
    this.searchSectionDisplay = 'SIB'
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
    if (this.userRoles) {
      APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
    }
    this.isExternal = this.APP_SETTINGS['isExternal'];
    this.hideNavbar = false;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const section = this.route.snapshot.queryParams['section'] || this.search_section;
        if (section) {
          this.search_section = section.toUpperCase();
          if(section.toUpperCase() === 'TRI'){
            this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
            this.searchSectionDisplay = this.userRoles['isMotorrad'] === 'true' ? 'AB' : this.search_section;
          } else {
            this.searchSectionDisplay = this.search_section;
          }
        }
      }
    });
    this.subsciption = this.utilityService.emit_dropdown$.subscribe(newDropdownValue => {
      this.search_section = newDropdownValue.toUpperCase();
      if(newDropdownValue.toUpperCase() === 'TRI'){
        this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
        this.searchSectionDisplay = this.userRoles['isMotorrad'] === 'true' ? 'AB' : this.search_section;
      } else {
        this.searchSectionDisplay = this.search_section;
      }
    });

    const styleCheck = setInterval(() => {
      this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
      if (this.userRoles) {
        APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
      }

      this.APP_SETTINGS = APP_SETTINGS;
      this.isExternal = this.APP_SETTINGS['isExternal'];

      if (this.APP_SETTINGS.isMINI === 'true') {
        this.setBackgroundStyle = { 'background-color': '#ff0000' };
        this.setFontStyle = { 'color': '#000000' };
        this.imgSrc = 'assets/images/MINI_symbol_RGB_black_30px.png';
        this.showCar = true;
        this.showBike = false;
      }
      if (this.APP_SETTINGS.isRollsRoyce === 'true') {
        this.setBackgroundStyle = { 'background-color': '#281432' };
        this.setFontStyle = { 'color': '#ffffff' };
        this.imgSrc = 'assets/images/RR_LOGO1.png';
        this.showCar = true;
        this.showBike = false;
        this.isCar = false;
        this.RRHideLegacy = true;
      }

      if (this.APP_SETTINGS.isBMW === 'true') {
        this.setBackgroundStyle = { 'background-color': '#1c69d4' };
        this.setFontStyle = { 'color': '#ffffff' };
        this.imgSrc = 'assets/images/bmw_logo.png';
        this.showCar = true;
        this.showBike = false;
      }

      if (this.APP_SETTINGS.isMOTORRAD === 'true') {
        this.setBackgroundStyle = { 'background-color': '#1c69d4' };
        this.setFontStyle = { 'color': '#ffffff' };
        this.imgSrc = 'assets/images/bmw_motorrad_logo.jpg';
        this.showBike = true;
        this.showCar = false;
        this.isCar = false;
        this.bulletinLabel = "Authority Bulletins";
      }
    if (this.APP_SETTINGS.isMINI != '' && this.APP_SETTINGS.isBMW != '' && this.APP_SETTINGS.isMOTORRAD != '' && this.APP_SETTINGS.isRollsRoyce != '') { 
        clearInterval(styleCheck);
        this.cdRef.detectChanges();
        if (this.APP_SETTINGS.isExternal == 'true') {
          this.subscription.push(this.userProfileService.getCurrentOSSLinks().subscribe(data => {
            if(data) {
              this.ossLinks = data.sort(function (a, b) { return a.linkOrder - b.linkOrder });;
            }
          }));
        }
      }
    }, 1000);
    
  }

  hideShowSearchInMobile(): void {
    this.hideShowSearchFlag = !this.hideShowSearchFlag;
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  selectValue(value: string) {
    this.search_section = value;
    if(value==='TRI' || value === 'tri'){
      this.searchSectionDisplay = this.bulletinLabel === 'Authority Bulletins' ? 'AB' : value;
    } else {
      this.searchSectionDisplay = value;
    }
    
  }

  searchKeyword(category: string): void {
    
    this.analyticsCallSearchKeywordByContentType(category.toLowerCase(), this.search_key);
    
    this.utilityService.passSearchKey(this.search_key);
    this.utilityService.changeDropdown(this.search_section);
    this.router.navigate(['/results', category.toLowerCase()],
      { queryParams: { key: this.search_key, section: category.toLowerCase() } });
  }

  analyticsCallSearchKeywordByContentType(contentTypesection, contentTypesearchkey) {
    let keywordCategory;
    if (contentTypesection === 'sib') {
      keywordCategory = 'Service Bulletins';
    }
    else if (contentTypesection === 'tri') {
      keywordCategory = 'TRI Bulletins';
    }
    else if (contentTypesection === 'of') {
      keywordCategory = 'Operation Fluids';
    }
    else if (contentTypesection === 'tm') {
      keywordCategory = 'Training Manuals';
    }
    else if (contentTypesection === 'faq') {
      keywordCategory = 'FAQ & Top Links';
    }
    else if (contentTypesection === 'obd') {
      keywordCategory = 'OBD';
    }
    else if (contentTypesection === 'te') {
      keywordCategory = 'Tools & Equipment';
    }
    else if (contentTypesection === 'td') {
      keywordCategory = 'Technical Documentation';
    }
    else if (contentTypesection === 'all') {
      keywordCategory = 'All';
    }
    this.analyticsService.trackClicksByContentTypeSearchKeywordLineMake(keywordCategory, contentTypesearchkey);
  }

  toggleNavbarCollapse() {
    this.navbar.nativeElement.click();
  }
  clearUserSessions() {
    localStorage.clear();
  }

  ngOnDestroy(): void {
    this.subsciption.unsubscribe();
  }
}
